import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from '../lib/axios';

const PageFilterContext = createContext();

export function PageFilterProvider({ children }) {
  const [branchPages, setBranchPages] = useState([]);
  const [selectedPageId, setSelectedPageId] = useState(null);
  const [dateRange, setDateRange] = useState({ startDate: null, endDate: null }); // {startDate: '2025-01-01', endDate: '2025-01-31'}

  const fetchBranchPages = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (!token) return;
    try {
      const response = await axios.get('/branch-pages');
      setBranchPages(response.data || []);
    } catch (error) {
      console.error('Failed to fetch branch pages');
    }
  }, []);

  useEffect(() => {
    fetchBranchPages();
    const handler = () => fetchBranchPages();
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, [fetchBranchPages]);

  return (
    <PageFilterContext.Provider value={{
      branchPages,
      selectedPageId,
      setSelectedPageId,
      dateRange,
      setDateRange,
      fetchBranchPages
    }}>
      {children}
    </PageFilterContext.Provider>
  );
}

export function usePageFilter() {
  const context = useContext(PageFilterContext);
  if (!context) {
    throw new Error('usePageFilter must be used within a PageFilterProvider');
  }
  return context;
}
